import { render } from "./_key.vue?vue&type=template&id=40837905&scoped=true&lang=pug"
import script from "./_key.vue?vue&type=script&lang=js"
export * from "./_key.vue?vue&type=script&lang=js"

import "./_key.vue?vue&type=style&index=0&id=40837905&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40837905"]])

export default __exports__